module.exports = {
	"config": {
		"linkPrefix": "/contracts",
		"name": "librebank-contracts",
		"version": "0.0.1",
		"description": "LibreBank emission and token contracts",
		"buildTime": "2018-03-20T09:57:17.364Z",
		"target": "doxity",
		"src": "contracts/*",
		"dir": "pages/docs",
		"out": "docs",
		"author": "decodedbrain, scientistnik, evercodex",
		"homepage": "https://librecash.github.io/contracts/docs/ComplexExchanger",
		"license": "AGPL-3.0",
		"interaction": {}
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "/home/scientistnik/workspace/librebank/contracts/doxity/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "docs",
				"stem": "_template",
				"path": "docs/_template.jsx",
				"absolute": "/home/scientistnik/workspace/librebank/contracts/doxity/docs/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "docs/_template.jsx",
			"templatePath": "/docs/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "BasicToken.json",
				"ext": "json",
				"name": "BasicToken",
				"extname": ".json",
				"basename": "BasicToken.json",
				"dirname": "docs",
				"stem": "BasicToken",
				"path": "docs/BasicToken.json",
				"absolute": "/home/scientistnik/workspace/librebank/contracts/doxity/docs/BasicToken.json",
				"isAbsolute": false
			},
			"requirePath": "docs/BasicToken.json",
			"path": "/docs/BasicToken/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "BurnableToken.json",
				"ext": "json",
				"name": "BurnableToken",
				"extname": ".json",
				"basename": "BurnableToken.json",
				"dirname": "docs",
				"stem": "BurnableToken",
				"path": "docs/BurnableToken.json",
				"absolute": "/home/scientistnik/workspace/librebank/contracts/doxity/docs/BurnableToken.json",
				"isAbsolute": false
			},
			"requirePath": "docs/BurnableToken.json",
			"path": "/docs/BurnableToken/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Claimable.json",
				"ext": "json",
				"name": "Claimable",
				"extname": ".json",
				"basename": "Claimable.json",
				"dirname": "docs",
				"stem": "Claimable",
				"path": "docs/Claimable.json",
				"absolute": "/home/scientistnik/workspace/librebank/contracts/doxity/docs/Claimable.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Claimable.json",
			"path": "/docs/Claimable/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ComplexExchanger.json",
				"ext": "json",
				"name": "ComplexExchanger",
				"extname": ".json",
				"basename": "ComplexExchanger.json",
				"dirname": "docs",
				"stem": "ComplexExchanger",
				"path": "docs/ComplexExchanger.json",
				"absolute": "/home/scientistnik/workspace/librebank/contracts/doxity/docs/ComplexExchanger.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ComplexExchanger.json",
			"path": "/docs/ComplexExchanger/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ERC20.json",
				"ext": "json",
				"name": "ERC20",
				"extname": ".json",
				"basename": "ERC20.json",
				"dirname": "docs",
				"stem": "ERC20",
				"path": "docs/ERC20.json",
				"absolute": "/home/scientistnik/workspace/librebank/contracts/doxity/docs/ERC20.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ERC20.json",
			"path": "/docs/ERC20/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ERC20Basic.json",
				"ext": "json",
				"name": "ERC20Basic",
				"extname": ".json",
				"basename": "ERC20Basic.json",
				"dirname": "docs",
				"stem": "ERC20Basic",
				"path": "docs/ERC20Basic.json",
				"absolute": "/home/scientistnik/workspace/librebank/contracts/doxity/docs/ERC20Basic.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ERC20Basic.json",
			"path": "/docs/ERC20Basic/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "I_Exchanger.json",
				"ext": "json",
				"name": "I_Exchanger",
				"extname": ".json",
				"basename": "I_Exchanger.json",
				"dirname": "docs",
				"stem": "I_Exchanger",
				"path": "docs/I_Exchanger.json",
				"absolute": "/home/scientistnik/workspace/librebank/contracts/doxity/docs/I_Exchanger.json",
				"isAbsolute": false
			},
			"requirePath": "docs/I_Exchanger.json",
			"path": "/docs/I_Exchanger/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "I_Oracle.json",
				"ext": "json",
				"name": "I_Oracle",
				"extname": ".json",
				"basename": "I_Oracle.json",
				"dirname": "docs",
				"stem": "I_Oracle",
				"path": "docs/I_Oracle.json",
				"absolute": "/home/scientistnik/workspace/librebank/contracts/doxity/docs/I_Oracle.json",
				"isAbsolute": false
			},
			"requirePath": "docs/I_Oracle.json",
			"path": "/docs/I_Oracle/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "LibreCash.json",
				"ext": "json",
				"name": "LibreCash",
				"extname": ".json",
				"basename": "LibreCash.json",
				"dirname": "docs",
				"stem": "LibreCash",
				"path": "docs/LibreCash.json",
				"absolute": "/home/scientistnik/workspace/librebank/contracts/doxity/docs/LibreCash.json",
				"isAbsolute": false
			},
			"requirePath": "docs/LibreCash.json",
			"path": "/docs/LibreCash/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Math.json",
				"ext": "json",
				"name": "Math",
				"extname": ".json",
				"basename": "Math.json",
				"dirname": "docs",
				"stem": "Math",
				"path": "docs/Math.json",
				"absolute": "/home/scientistnik/workspace/librebank/contracts/doxity/docs/Math.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Math.json",
			"path": "/docs/Math/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Migrations.json",
				"ext": "json",
				"name": "Migrations",
				"extname": ".json",
				"basename": "Migrations.json",
				"dirname": "docs",
				"stem": "Migrations",
				"path": "docs/Migrations.json",
				"absolute": "/home/scientistnik/workspace/librebank/contracts/doxity/docs/Migrations.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Migrations.json",
			"path": "/docs/Migrations/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "MintableToken.json",
				"ext": "json",
				"name": "MintableToken",
				"extname": ".json",
				"basename": "MintableToken.json",
				"dirname": "docs",
				"stem": "MintableToken",
				"path": "docs/MintableToken.json",
				"absolute": "/home/scientistnik/workspace/librebank/contracts/doxity/docs/MintableToken.json",
				"isAbsolute": false
			},
			"requirePath": "docs/MintableToken.json",
			"path": "/docs/MintableToken/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Ownable.json",
				"ext": "json",
				"name": "Ownable",
				"extname": ".json",
				"basename": "Ownable.json",
				"dirname": "docs",
				"stem": "Ownable",
				"path": "docs/Ownable.json",
				"absolute": "/home/scientistnik/workspace/librebank/contracts/doxity/docs/Ownable.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Ownable.json",
			"path": "/docs/Ownable/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "SafeMath.json",
				"ext": "json",
				"name": "SafeMath",
				"extname": ".json",
				"basename": "SafeMath.json",
				"dirname": "docs",
				"stem": "SafeMath",
				"path": "docs/SafeMath.json",
				"absolute": "/home/scientistnik/workspace/librebank/contracts/doxity/docs/SafeMath.json",
				"isAbsolute": false
			},
			"requirePath": "docs/SafeMath.json",
			"path": "/docs/SafeMath/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "StandardToken.json",
				"ext": "json",
				"name": "StandardToken",
				"extname": ".json",
				"basename": "StandardToken.json",
				"dirname": "docs",
				"stem": "StandardToken",
				"path": "docs/StandardToken.json",
				"absolute": "/home/scientistnik/workspace/librebank/contracts/doxity/docs/StandardToken.json",
				"isAbsolute": false
			},
			"requirePath": "docs/StandardToken.json",
			"path": "/docs/StandardToken/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "",
				"stem": "index",
				"path": "index.md",
				"absolute": "/home/scientistnik/workspace/librebank/contracts/doxity/index.md",
				"isAbsolute": false
			},
			"requirePath": "index.md",
			"path": "/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 386
// module chunks = 0